import { SECTION_HEIGHT_UPDATED as type } from '@shopDetails/actionTypes';
import getSectionsHeights from '@shopDetails/selectors/getSectionsHeights';

const onSectionHeightUpdated = (index, height) => (dispatch, getState) => {
  if (height) {
    const heights = getSectionsHeights(getState());
    const actualHeight = heights[index];
    if (actualHeight !== height) {
      dispatch({ type, payload: { index, height } });
    }
  }
};

export default onSectionHeightUpdated;
